import { Alert, Button, Container, Grid, Rating, TextField, Typography } from "@mui/material";
import DocumentReviewItem from "../../components/DocumentReviewItem";
import { useEffect, useState } from "react";
import { Backend } from "../../services/Backend";
import { Link, useNavigate, useParams } from "react-router-dom";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { userHasPermissions } from "../../utils/utils";
import { UserPermissions } from "../../dto/Permissions";
import Loader from "../../components/Loader";
import moment from "moment";

export default function UrlPreviewPage() {
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();
    const { id } = useParams();
    const [url, setUrl] = useState({});
    const [reviews, setReviews] = useState([]);

    const [error, setError] = useState();
    const [review, setReview] = useState("");
    const [rating, setRating] = useState(0);

    useEffect(() => {
        Backend.get(`url/${id}`)
            .then(res => setUrl(res));

        Backend.get(`url/${id}/review`)
            .then(res => {
                setReviews(res);
                setIsLoading(false);
            });
    }, []);

    const sendReview = () => {
        setError("");
         
        if (rating === 0) {
            setError("Rating is required");
            return;
        } 

        if (review === "") {
            setError("Review is required");
            return;
        }

        Backend.post(`url/${id}/review`, { text: review, rating: rating })
            .then(res => {
                setReview("");
                setRating(0);
                Backend.get(`url/${id}/review`)
                .then(res => {
                    setReviews(res);
                });
            });
    }

    const backHandler = (e) => {
        e.preventDefault();

        navigate(-1);
    }

    return <Container maxWidth="lg" className="my-5">
        <Link to="#" onClick={backHandler}>Back</Link>
        <br />
        <br />
        {isLoading ? <div className="mx-auto w-fit mt-4"><Loader /></div> : <>
        <b className="text-4xl">{url.title} </b>
        <Rating value={reviews.reduce((partialSum, r) => partialSum + r.rating, 0) / reviews.length} readOnly  />
        <br />
        <i>{moment(url.uploadDate).local().format("YYYY-MM-DD")}</i>
        <br />
        <br />
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <b>Interest: </b> <span>{url.interest}</span>
            </Grid>
            <Grid item xs={6}>
                <b>Language: </b> <span>{url.language}</span>
            </Grid>
            <Grid item xs={6}>
                <b>Url: </b> <a href={url.url?.includes("http") ? url?.url : `http://${url.url}`} target="_blank" className="text-blue-500 hover:text-blue-700 hover:underline">{url.url}</a>
            </Grid>
            <Grid item xs={6}>
                <b>Upload by company: </b> <span>{url.uploadByCompany ? "yes" : "no" }</span>
            </Grid>
            <Grid item xs={12}>
                <b>Description: </b> <span>{url.description}</span>
            </Grid>
        </Grid>
        <br />

        <br />
        <hr />
        <br />

        <div className="flex items-center gap-2 mb-1">
            <TextField size="small"  fullWidth label="Wirte review" value={review} onChange={(e) => setReview(e.target.value)}/>
            <Button variant="contained" onClick={sendReview}>Send</Button>
        </div>
        <Rating value={rating} onChange={(e, newValue) => setRating(newValue)}/>
        <br />
        {error && (<>
            <Alert severity="error">{error}</Alert>
            <br />
        </>) }
        
        <br />
        <h3 className="text-2xl">Reviews</h3>
        { reviews.length === 0 ? "No reviews" : ""}
        {reviews.map(item => <DocumentReviewItem data={item}/>)}
        </>}

    </Container>
}